import Vue from 'vue';
import VueRouter from 'vue-router';
import store from './store';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/prelude',
      name: 'prelude',
      component: () => import(/* webpackChunkName: "prelude" */ '../components/prelude/Prelude.vue'),
      beforeEnter(to, from, next) {
        if (store.getters.isAuthenticated) {
          next('/');
        } else {
          next();
        }
      },
    },
    {
      path: '/',
      name: 'home',
      component: () => import(/* webpackChunkName: "home" */ '../components/home/Home.vue'),
      beforeEnter(to, from, next) {
        if (!store.getters.isAuthenticated) {
          next('/prelude');
        } else {
          next();
        }
      }
    },
    {
      path: '/editor',
      name: 'editor',
      component: () => import(/* webpackChunkName: "editor" */ '../components/editor/Editor.vue'),
      beforeEnter(to, from, next) {
        if (!store.getters.isAuthenticated) {
          next('/prelude');
        } else {
          next();
        }
      }
    },
    {
      path: '/editor/sandbox',
      name: 'sandbox',
      component: () => import(/* webpackChunkName: "editor-sandbox" */ '../components/editor/Sandbox.vue'),
      beforeEnter(to, from, next) {
        if (!store.getters.isAuthenticated) {
          next('/prelude');
        } else {
          next();
        }
      }
    }
  ]
});

export default router;
